import { useContext } from "react";
import { CustomerAuthContext } from "./customerAuthContext";

const useCustomerAuth = () => useContext(CustomerAuthContext);

export default useCustomerAuth;
